{
  "success": true,
  "message": "Sesión cerrada correctamente"
}
